import * as React from 'react';

const CusHr = (props) => {

    return (

        <div className="row around-xs inputPair elementVisible" style={props.style}>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                {props.lblname !== '' && <label className="box text-left" style={{ fontSize: '1em' }}>
                    <b>{props.lbtxt}</b></label>}

                <hr className="hrgoldline" />
            </div>
        </div>
    )
}

export default CusHr;